/*
pendingWithdrawals/view.js

create and handle all dom-nodes for the pending withdrawals
all dom-updates are routed from this module.

*/
import core from '../../common/lib/core.js';
import viewPendingWithdrawals from './view-pending-withdrawals.js';
import viewSpinner from '../../commonview/lib/view-spinner.js';
import viewWrap from '../../commonview/lib/view-wrap.js';
import notifications from '../../commonview/lib/view-binaryquestion.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const selectors = {
	textkeys: '.textkeys__payments',
	wrap: null
		// set selector to wrapper in navigation files, router.js.
		// template: app/packages/mobile-core-assets/templates/html/deposit/withdrawal-cancel.mustache
};
let elements;
let textkeysObj = {};
let viewSpinnerInstance = null;

function deleteAllElements() {
	core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'pendingwithdrawals/view:23'); /* the 'selectors' object contains the keys to all elements */
}

export default {
	init(conf) {
		selectors.wrap = (conf.wrap || selectors.wrap);
		selectors.textkeys = (conf.textkeys || selectors.textkeys);
		elements = core.selectElements(selectors, 'pendingwithdrawals:view');
		textkeysObj = viewTextkeys.depositflow();

		viewPendingWithdrawals.init({
			wrap: elements.wrap,
			origin: (conf.origin || null),
			textkeysObj,
		});
		viewSpinnerInstance = viewSpinner.create({
			wrap: elements.wrap
		});
		viewWrap.show((elements && elements.wrap));
		viewSpinnerInstance.show();
	},
	update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		const textKeyFailure = (textkeysObj['cancel-withdraw-general-failure'] || 'textkey-missing-cancel-withdraw');
		if (state && state.pending_withdrawals) {
			viewPendingWithdrawals.update(state);
			viewSpinnerInstance.hide();
		}
		if (state && state.fetch_cancel_withdraw) {
			viewSpinnerInstance.hide();
			if (state.failure) {
				notifications.showNotification(textKeyFailure, 'red', true);
			} else {
				viewPendingWithdrawals.update(state);
			}
		}
	},
	close() {
		deleteAllElements();
		if (viewSpinnerInstance) {
			viewSpinnerInstance.close();
		}
		viewPendingWithdrawals.close();
		viewWrap.hide((elements && elements.wrap));
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/lib/view.js